
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 37 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_i_1029_2679)"}},[_c('circle',{attrs:{"cx":"18.5","cy":"18.5","r":"18.5","fill":"#111","fill-opacity":".63"}})]),_c('circle',{attrs:{"cx":"18.5","cy":"18.5","r":"18","stroke":"gray","stroke-opacity":".07"}}),_c('path',{attrs:{"d":"M21.07 11.429L14 18.5l7.07 7.071","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_i_1029_2679","x":"0","y":"0","width":"37","height":"37","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feMorphology',{attrs:{"radius":".25","in":"SourceAlpha","result":"effect1_innerShadow_1029_2679"}}),_c('feOffset'),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"arithmetic","k2":"-1","k3":"1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.21 0"}}),_c('feBlend',{attrs:{"in2":"shape","result":"effect1_innerShadow_1029_2679"}})])])])
          )
        }
      }
    